import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse } from 'axios';
import { GetFileData, STORE_SIGNEDURL_STL } from 'src/reducers/rxForm';
// import { push } from 'react-router-redux';
// import { fromDate } from './completeOrderAction';

export const renderSTLImage = (filesData: GetFileData[]) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const filteredStlFiles = filesData.filter(r => (r.filetype === 'STL File' && r.filename.split('.').reverse()[0] === 'stl'));
        const signedUrlStl: Array<string> = [];
        console.log(filesData, 'filesDatafilesData');

        for (const file of filteredStlFiles) {     
            let downloadFrom = 'getDownloadUrl';

            if (file.oci_status && file.oci_status === '1') {
                downloadFrom = 'getODownloadUrl';
            }

            const filePath = encodeURIComponent(file.filename);
            await axios({
                method: 'get',
                url: `${getState().environment.API_URL}${downloadFrom}?fullPath=${filePath}`,
            }).then(function (response: AxiosResponse) {
                signedUrlStl.push(response.data.signedUrl);

            }).catch(function (error: AxiosResponse) {
                // ==> console.error(error);
            });

        }
        dispatch({ type: STORE_SIGNEDURL_STL, signedUrlStl } as AnyAction);
        if (getState().UserRxFormData.signedUrlStl.length === filteredStlFiles.length) {

            const formElement = document.createElement('form');
            formElement.style.display = 'none';
            formElement.action = `${getState().environment.DESIGNER_PORTAL_URL}stlViewer`;
            formElement.method = 'POST';
            formElement.target = '_blank';
            formElement.id = 'myForm';
            const element = document.createElement('input');
            element.setAttribute('value', JSON.stringify(signedUrlStl));
            element.setAttribute('name', 'urls');
            formElement.appendChild(element);
            document.body.appendChild(formElement);
            formElement.submit();

        }

        return true;
    };
};



// WEBPACK FOOTER //
// ./src/actions/stlViewerAction.ts